import config from '@src/config';
import APP_ROUTES from '@src/app_routes';

// isAdminUser variable is derived from user.role === 1

const getMenuItems = (featurePermissions, isAdminUser) => {
  const { CONTACTS_ENABLED, INSIGHTS_ENABLED } = featurePermissions;

  const contactsEnabled = CONTACTS_ENABLED?.value ?? false;
  const insightsEnabled = INSIGHTS_ENABLED?.value ?? false;

  const menuItems = [
    {
      text: 'Clients',
      url: APP_ROUTES.admin,
      shouldShowOnMenu: isAdminUser,
    },
    {
      text: 'Campaigns',
      url: APP_ROUTES.campaignList,
      shouldShowOnMenu: !isAdminUser,
    },
    {
      text: 'Media',
      url: APP_ROUTES.submissionsList,
      shouldShowOnMenu: !isAdminUser,
    },
    {
      text: 'Publishing',
      url: APP_ROUTES.videoLibraries,
      subpages: [
        { text: 'Plugins', url: APP_ROUTES.pluginsList },
        { text: 'Video Library', url: APP_ROUTES.videoLibraries },
      ],
      shouldShowOnMenu: !isAdminUser,
    },
    {
      text: 'Contacts',
      url: APP_ROUTES.contacts,
      shouldShowOnMenu: !isAdminUser && contactsEnabled,
    },
    {
      text: 'Insights',
      url: APP_ROUTES.insights,
      shouldShowOnMenu: !isAdminUser && insightsEnabled,
    },
  ];

  return menuItems.filter((item) => item.shouldShowOnMenu);
};

const getSettingsDropDown = (isAdminUser, featurePermissions) => {
  const { MULTIUSER_SEATS } = featurePermissions;

  const isMultiuserEnabled = Number(MULTIUSER_SEATS?.value) > 0;

  const settingsOptions = [
    { text: 'Billing', url: APP_ROUTES.billing, shouldShowOnMenu: !isAdminUser },
    {
      text: 'Users',
      url: APP_ROUTES.organization,
      shouldShowOnMenu: !isAdminUser && isMultiuserEnabled,
    },
    {
      text: 'Change Password',
      url: APP_ROUTES.changePassword,
      shouldShowOnMenu: true,
    },
    {
      text: 'Sign Out',
      shouldShowOnMenu: true,
    },
  ];

  return settingsOptions.filter((item) => item.shouldShowOnMenu);
};

const getIconsMenu = () => {
  return [
    {
      text: 'Help Center',
      url: config.helpCenterLink,
      icon: 'HelpCircle',
    },
    { text: 'Settings', url: APP_ROUTES.settings, icon: 'Settings' },
  ];
};

/**
 * Get menu by role and feature toggle
 */
const getMenuByUserRoleAndFeatureAccess = (isAdminUser, featurePermissions) => {
  const tabMenuItems = getMenuItems(featurePermissions, isAdminUser);

  const iconMenuItems = getIconsMenu();

  const settingsMenuItems = getSettingsDropDown(isAdminUser, featurePermissions);

  return {
    tabMenuItems,
    iconMenuItems,
    settingsMenuItems,
  };
};

export default getMenuByUserRoleAndFeatureAccess;



// WEBPACK FOOTER //
// ./src/redux/data/menu.js